<template lang="pug">
  div
    div.spinner.spinner-border.spinner-border-lg.text-primary(v-if="ordering")
    order-step(:current-step="3")
    h2 Lieferung
    div.px-4.py-4
      div Ihre Bestellung wird an die folgende Adresse geliefert:
      br
      div.py-2(v-if="deliveryAddress")
        .form-group.row
          label.col-sm-2.col-form-label(for="i-name1") Zeile 1
          .col-sm-5
            input#i-name1(v-model="deliveryAddress.name1" :class="[{ 'is-invalid': validationMessages['ADDRESS_TYPE_DELIVERY.name1'] }, 'form-control form-control-sm']")
            .error.invalid-feedback(v-if="validationMessages['ADDRESS_TYPE_DELIVERY.name1']") {{ validationMessages['ADDRESS_TYPE_DELIVERY.name1'] }}
        .form-group.row
          label.col-sm-2.col-form-label(for="i-name2") Zeile 2
          .col-sm-5
            input.form-control.form-control-sm(v-model="deliveryAddress.name2" :class="[{ 'is-invalid': validationMessages['ADDRESS_TYPE_DELIVERY.name2'] }, 'form-control form-control-sm']")
            .error.invalid-feedback(v-if="validationMessages['ADDRESS_TYPE_DELIVERY.name2']") {{ validationMessages['ADDRESS_TYPE_DELIVERY.name2'] }}
        .form-group.row
          label.col-sm-2.col-form-label(for="i-street") Straße
          .col-sm-5
            input.form-control.form-control-sm(v-model="deliveryAddress.street" :class="[{ 'is-invalid': validationMessages['ADDRESS_TYPE_DELIVERY.street'] }, 'form-control form-control-sm']")
            .error.invalid-feedback(v-if="validationMessages['ADDRESS_TYPE_DELIVERY.street']") {{ validationMessages['ADDRESS_TYPE_DELIVERY.street'] }}
        .form-group.row
          label.col-sm-2.col-form-label(for="i-zip") PLZ
          .col-sm-5
            input.form-control.form-control-sm(v-model="deliveryAddress.zip" :class="[{ 'is-invalid': validationMessages['ADDRESS_TYPE_DELIVERY.zip'] }, 'form-control form-control-sm']")
            .error.invalid-feedback(v-if="validationMessages['ADDRESS_TYPE_DELIVERY.zip']") {{ validationMessages['ADDRESS_TYPE_DELIVERY.zip'] }}
        .form-group.row
          label.col-sm-2.col-form-label(for="i-city") Stadt
          .col-sm-5
            input.form-control.form-control-sm(v-model="deliveryAddress.city" :class="[{ 'is-invalid': validationMessages['ADDRESS_TYPE_DELIVERY.city'] }, 'form-control form-control-sm']")
            .error.invalid-feedback(v-if="validationMessages['ADDRESS_TYPE_DELIVERY.city']") {{ validationMessages['ADDRESS_TYPE_DELIVERY.city'] }}
        .form-group.row
          label.col-sm-2.col-form-label(for="i-country") Land
          .col-sm-5
            select(v-model="deliveryAddress.country" :class="[{ 'is-invalid': validationMessages['ADDRESS_TYPE_DELIVERY.country'] }, 'form-control form-control-sm form-select form-select-sm']")
              option(value="DE" :selected="deliveryAddress.country === 'DE' || (deliveryAddress.country !== 'DE' && deliveryAddress.country !== 'AT')") Deutschland
              option(value="AT" :selected="deliveryAddress.country === 'DE'") Österreich
            .error.invalid-feedback(v-if="validationMessages['ADDRESS_TYPE_DELIVERY.country']") {{ validationMessages['ADDRESS_TYPE_DELIVERY.country'] }}
      div Falls eine Korrektur notwendig ist, rufen Sie uns bitte an unter&nbsp;
        strong.no-wrap +49 (0)8131 / 390 - 02
    div.px-4.py-4
      div Ihre Bestellung wird mit DHL ausgeliefert.
      form.my-3(@submit.prevent)
        div.form-group.form-check.fat-checkbox
          input.form-check-input(type="radio" id="versand" checked)
          label.form-check-label(for="versand")
            | Versandkostenpauschale:&nbsp;
            b {{ orderSummary.shippingCosts }}
    div.card-footer.text-right(v-if="orderSummary")
      span.mb-2.d-flex.flex-wrap.justify-content-end
        span.no-wrap(v-if="customer && customer.studentProducts === 1") Preis:&nbsp;
          strong.no-wrap {{ orderSummary.totalPriceB2c }}
        span.no-wrap(v-else) Preis:&nbsp;
          strong.no-wrap {{ orderSummary.totalPriceB2b }}
        span.mx-2 &middot;
        span.no-wrap Menge:&nbsp;
          strong.no-wrap {{ orderSummary.totalQuantity }}
        span.mx-2 &middot;
        span.no-wrap {{ discountLabel }}:&nbsp;
          strong.no-wrap {{ orderSummary.onlineDiscount }}
        span.mx-2 &middot;
        span.no-wrap Versand:&nbsp;
          strong.no-wrap {{ orderSummary.shippingCosts }}
        span.mx-2 &middot;
        span.no-wrap {{ orderSummary.vatPercentage }}:&nbsp;
          strong.no-wrap {{ orderSummary.vat }}
        span.mx-2 &middot;
        span.no-wrap Gesamt:&nbsp;
          strong.no-wrap {{ orderSummary.totalPrice }}
      button.mr-2.btn.btn-secondary(
        type="button"
        @click="goBack"
        )
        | Zurück
      button.btn.btn-primary.btn-lg(
        :disabled="!(validatedInitially && Object.keys(validationMessages).length == 0)"
        type="button"
        @click="showPayment"
        )
        | Weiter
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import OrderStep from '@/components/orderForm/orderStep'
import OrderNotes from '@/components/orderForm/orderNotes'
import { AddressType } from '@/proto/common/common_pb'

export default {
  name: 'DeliveryAddress',
  components: {
    OrderNotes,
    OrderStep
  },
  data: () => ({
    validatedInitially: false,
    validationMessages: {},
    plannedValidation: null,
    deliveryAddress: {
      addressType: AddressType.ADDRESS_TYPE_DELIVERY,
      name1: null,
      name2: null,
      street: null,
      zip: null,
      city: null,
      country: null
    }
  }),
  computed: {
    ...mapGetters('authentication', [
      'customer'
    ]),
    ...mapState('orderForm', [
      'orderSummary'
    ]),
    ...mapState({
      ordering: state => !!state.orderFormService.loadingIndicators.createOrder
    }),
    discountLabel () {
      // Check if customer is a student
      if (this.customer && this.customer.studentProducts === 1) {
        return 'Schüler-Rabatt 10%'
      }
      return 'Online-Rabatt 3%'
    }
  },
  watch: {
    deliveryAddress: {
      handler () {
        clearTimeout(this.plannedValidation)
        this.plannedValidation = setTimeout(this.validate, 500)
      },
      deep: true
    }
  },
  mounted () {
    if (this.customer.deliveryAddress) {
      this.deliveryAddress.name1 = this.customer.deliveryName1
      this.deliveryAddress.name2 = this.customer.deliveryName2
      this.deliveryAddress.street = this.customer.deliveryStreet
      this.deliveryAddress.zip = this.customer.deliveryZip
      this.deliveryAddress.city = this.customer.deliveryCity
      this.deliveryAddress.country = this.customer.deliveryCountry
    } else {
      this.deliveryAddress.name1 = this.customer.name1
      this.deliveryAddress.name2 = this.customer.name2
      this.deliveryAddress.street = this.customer.street
      this.deliveryAddress.zip = this.customer.zip
      this.deliveryAddress.city = this.customer.city
      this.deliveryAddress.country = this.customer.country
    }
    this.validate()
  },
  methods: {
    ...mapActions('ui', [
      'goBack',
      'showPayment'
    ]),
    ...mapActions('orderFormService', [
      'validateAddress'
    ]),
    ...mapMutations('orderForm', [
      'setDeliveryAddress'
    ]),
    setValidationMessages (messagesMap, address) {
      let messages = {}
      messagesMap.forEach(item => {
        messages[item[0]] = item[1]
      })
      this.validationMessages = messages
      this.validatedInitially = true
      if (Object.keys(messages).length === 0) {
        this.setDeliveryAddress(address)
      } else {
        this.setDeliveryAddress({})
      }
    },
    async validate () {
      this.plannedValidation = null
      if (await this.validateAddress({
        address: this.deliveryAddress
      })) {
        this.setValidationMessages(this.$store.state.orderFormService.latestRequests.validateAddress.response.messagesMap, this.deliveryAddress)
      }
    }
  }
}
</script>
